import gql from "graphql-tag";

export const mutationDeleteUseCase = gql`
  mutation DeleteUseCase($useCaseKey: String!) {
    cloudPlatform {
      deleteUseCase(useCaseKey: $useCaseKey)
    }
  }
`;
